import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { mask } from 'remask';
//
import { validaCpf } from '../../functions/validaCpf';
import { validaCnpj } from '../../functions/validaCnpj';
//
import apiPlay from '../../services/apiPlay';
import apiCep from '../../services/apiCep';
//
import Botao from '../Botao';
import Checkbox from '../Checkbox';
//
import AmexImg from '../../assets/logos/amex.svg';
import BanescardImg from '../../assets/logos/banescard.svg';
import CabalImg from '../../assets/logos/cabal.svg';
import DinnersImg from '../../assets/logos/diners.svg';
import DiscoverImg from '../../assets/logos/discover.svg';
import EloImg from '../../assets/logos/elo.svg';
import HipercardImg from '../../assets/logos/hipercard.svg';
import MastercardImg from '../../assets/logos/mastercard.svg';
import VisaImg from '../../assets/logos/visa.svg';
import VaziaImg from '../../assets/bandeira_vazia.png';
import SslImg from '../../assets/site_seguro_imagem.png';
//
import styles from './TelaRecorrencia.module.css';
import { DragHandleDots2Icon, TrashIcon } from '@radix-ui/react-icons';
import SortableList, { SortableItem, SortableKnob } from 'react-easy-sort';
import { arrayMoveImmutable } from 'array-move';

const getBandeiraCartao = (value) => {
  switch (value) {
    case 'AMEX': return AmexImg;
    case 'BANESCARD': return BanescardImg;
    case 'CABAL': return CabalImg;
    case 'DINERS': return DinnersImg;
    case 'DISCOVER': return DiscoverImg;
    case 'ELO': return EloImg;
    case 'HIPERCARD': return HipercardImg;
    case 'MASTERCARD': return MastercardImg;
    case 'VISA': return VisaImg;
    case 'CREDZ': return VisaImg;
    default: return VaziaImg;
  }
};

function detectBrand(num) {
  if (!num) return null;
  if (num.startsWith('4')) return { name: 'visa', logo: VisaImg };
  if (num.startsWith('5')) return { name: 'mastercard', logo: MastercardImg };
  if (num.startsWith('34') || num.startsWith('37')) return { name: 'amex', logo: AmexImg };
  if (num.startsWith('36') || num.startsWith('38') || num.startsWith('301') || num.startsWith('305'))
    return { name: 'elo', logo: EloImg };
  if (num.startsWith('60') || num.startsWith('3841')) return { name: 'hipercard', logo: HipercardImg };
  if (num.startsWith('6011') || num.startsWith('65')) return { name: 'discover', logo: DiscoverImg };
  return null;
}

export default function TelaRecorrencia({ fatura, payId, cartoesInitial, isRecActive }) {
  // STATES
  const [loadingPag, setLoadingPag] = useState(false);
  const [emailTitular, setEmailTitular] = useState('');
  const [cep, setCep] = useState('');
  const [endereco, setEndereco] = useState('');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [numCartao, setNumCartao] = useState('');
  const [nomeCartao, setNomeCartao] = useState('');
  const [mesVencimento, setmesVencimento] = useState('');
  const [anoVencimento, setAnoVencimento] = useState('');
  const [cvv, setCvv] = useState('');
  const [pagarAgora, setPagarAgora] = useState(false);
  const [dataCobranca, setDataCobranca] = useState('');
  const [mostraAddCartao, setMostraAddCartao] = useState(false);
  const [isEditCards, setIsEditCards] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const [cartoes, setCartoes] = useState(cartoesInitial);

  const contaFatura = fatura.contafatura;
  const anoAtual = new Date().getFullYear().toString();
  const brand = detectBrand(numCartao);

  // ── API Functions (original PlayMovel) ──

  function realizaPagamento() {
    setLoadingPag(true);

    let dados = {
      payid: payId,
      pagacartao: '1',
      nomeCartao: nomeCartao,
      numero: numCartao,
      expirames: mesVencimento,
      expiraano: '20' + anoVencimento,
      ccv: cvv,
      nome: '',
      email: '',
      cpfCnpj: cpfCnpj,
      postalCode: '',
      endereconumero: '',
      enderecocomplemento: '',
      telefone: fatura.msisdn,
      telefonecelular: '',
    };

    apiPlay.post('/api/asaasfatura', dados).then((response) => {
      if (response.data.status === 'CONFIRMED') {
        toast.success('Pagamento Efetuado! Em alguns minutos sua linha será recarregada.');
        ativaRecorrencia();
      }

      if (response.data.status !== 'CONFIRMED') {
        if (!!response.data.errors.length) {
          toast.error(response.data.errors[0].description);
        } else {
          toast.error('Erro ao efetuar pagamento.');
        }
        setLoadingPag(false);
      }
    });
  }

  function ativaRecorrencia() {
    setLoadingPag(true);

    let dados = {
      cpf: fatura.cpf,
      statusrec: true,
      msisdn: fatura.msisdn,
    };

    apiPlay
      .post('/api/recorrencia/statusrecorrencia', dados)
      .then((response) => {
        toast.success('Recorrência ativada com sucesso!');
        setTimeout(() => { window.location.reload(); }, 2000);
      })
      .catch((error) => {
        if (error?.response?.status === 590) {
          toast.error('Cartão principal não foi cadastrado');
        } else {
          toast.error('Erro ao ativar recorrência');
        }
      })
      .finally(() => { setLoadingPag(false); });
  }

  function desativaRecorrencia() {
    setLoadingPag(true);

    let dados = {
      msisdn: fatura.msisdn,
      cpf: fatura.cpf,
      statusrec: false,
    };

    apiPlay
      .post('/api/recorrencia/statusrecorrencia', dados)
      .then((response) => {
        toast.info('Recorrência desativada com sucesso!');
        setLoadingPag(false);
        setTimeout(() => { window.location.reload(); }, 2000);
      })
      .catch((error) => {
        console.log(error);
        toast.error('Erro ao desativar recorrência');
        setLoadingPag(false);
      });
  }

  function addCard(e) {
    e.preventDefault();

    if (!!contaFatura && dataCobranca > 31) {
      toast.error('Informe um dia válido para cobrança');
      return;
    }

    setLoadingPag(true);

    let dados = {
      name: nomeCartao,
      cpf: fatura.cpf,
      numerocartao: numCartao,
      expirames: mesVencimento,
      expiraano: '20' + anoVencimento,
      ccv: cvv,
      email: emailTitular,
      telefone: !!contaFatura ? undefined : fatura.msisdn,
      cep: cep,
      endereco: endereco,
      card_id: cartoes.length + 1,
      cpfcartao: cpfCnpj,
      vencimento: !!contaFatura ? dataCobranca : undefined,
    };

    apiPlay
      .post('/api/recorrencia/cadastraCartao', dados)
      .then((response) => {
        if (pagarAgora) realizaPagamento();
        toast.success('Cartão adicionado com sucesso!');
        setTimeout(() => { window.location.reload(); }, 2000);
      })
      .catch((error) => {
        console.log(error);
        if (error?.response?.data?.error) {
          toast.error(error.response.data.error);
        } else {
          toast.error('Erro ao adicionar cartão');
        }
      })
      .finally(() => { setLoadingPag(false); });
  }

  const removeCard = (id) => {
    const confirmou = window.confirm('Deseja remover este cartão?');
    if (!confirmou) return;
    setCartoes((prevCartoes) => prevCartoes.filter((cartao) => cartao.cartão !== id));
  };

  const onSortEnd = (oldIndex, newIndex) => {
    setCartoes((array) => arrayMoveImmutable(array, oldIndex, newIndex));
  };

  const alteraOrdemCartoes = () => {
    setLoadingPag(true);

    const payload = {
      token: process.env.REACT_APP_TOKEN_API,
      card1: cartoes[0]?.cartão,
      card2: cartoes[1]?.cartão,
      card3: cartoes[2]?.cartão,
      cpf: fatura.cpf,
    };

    setIsEditCards((prev) => !prev);

    apiPlay
      .post('/api/recorrencia/alteraCartoes', payload)
      .then((response) => {
        toast.success('Cartões atualizados com sucesso!');
      })
      .catch((error) => {
        console.log(error);
        toast.error('Erro ao atualizar cartões');
      })
      .finally(() => { setLoadingPag(false); });
  };

  // CEP lookup
  useEffect(() => {
    function buscaCEP() {
      apiCep
        .get('/' + cep + '/json')
        .then((response) => {
          const res = response.data;
          setEndereco(`${res.uf} ${res.localidade} ${res.bairro} ${res.logradouro}`);
        })
        .catch((error) => { console.log(error); });
    }

    if (cep.length === 8) {
      buscaCEP();
    }
  }, [cep]);

  // ── Computed display values ──
  const formattedNum = mask(numCartao, ['9999 9999 9999 9999']);
  const displayNum = formattedNum || '•••• •••• •••• ••••';
  const displayName = nomeCartao || 'NOME DO TITULAR';
  const displayExp = (mesVencimento || '••') + '/' + (anoVencimento || '••');

  return (
    <section className={styles['container']}>
      {/* ── Meus Cartões ── */}
      <span className={styles['title']}>Meus cartões</span>

      {cartoes.length >= 1 ? (
        <div className={styles['cartoes-container']}>
          <SortableList
            onSortEnd={onSortEnd}
            className={styles['sortable-container']}
            draggedItemClassName={styles['dragged']}
            lockAxis="y"
            allowDrag={cartoes.length > 1 && isEditCards}
          >
            {cartoes.map((cartao, index) => (
              <SortableItem key={cartao.cartão}>
                <div className={styles['cartao-container']}>
                  <div className={styles['cartao']}>
                    <span className={styles['secondary']}>Opção {index + 1}</span>
                    <img
                      className={styles['bandeiras']}
                      src={getBandeiraCartao(cartao.bandeira)}
                      alt="bandeira-cartao"
                    />
                    <span>**** **** **** {cartao.ult4}</span>
                  </div>

                  {cartoes.length > 1 && isEditCards && (
                    <SortableKnob>
                      <DragHandleDots2Icon width={18} height={18} />
                    </SortableKnob>
                  )}
                  {isEditCards && (
                    <TrashIcon
                      color="red"
                      width={18}
                      height={18}
                      onClick={() => removeCard(cartao.cartão)}
                    />
                  )}
                </div>
              </SortableItem>
            ))}
          </SortableList>
        </div>
      ) : (
        <span className={styles['secondary']} style={{ marginTop: '0.5rem' }}>
          Não há cartões cadastrados
        </span>
      )}

      {/* ── Botões de ação ── */}
      <div className={styles['actions-row']}>
        {isRecActive ? (
          <Botao
            text="Desabilitar Recorrência"
            loading={loadingPag}
            color="error"
            style={{ margin: 0 }}
            onClick={desativaRecorrencia}
          />
        ) : (
          <Botao
            text="Ativar Recorrência"
            loading={loadingPag}
            color="primary"
            style={{ margin: 0, backgroundColor: 'var(--color-success)' }}
            onClick={ativaRecorrencia}
          />
        )}

        {(cartoes.length > 0 || isEditCards) && (
          <Botao
            text={!isEditCards ? 'Alterar Cartões' : 'Salvar Alterações'}
            loading={loadingPag}
            color="primary"
            style={{ margin: 0 }}
            onClick={!isEditCards ? () => setIsEditCards((prev) => !prev) : alteraOrdemCartoes}
          />
        )}

        <Botao
          disabled={cartoes.length >= 3 || isEditCards}
          text={!mostraAddCartao || isEditCards ? 'Adicionar novo cartão' : 'Cancelar'}
          loading={loadingPag}
          color="primary-g"
          style={{ margin: 0 }}
          onClick={() => setMostraAddCartao((prev) => !prev)}
        />
      </div>

      {/* ── Formulário de adicionar cartão ── */}
      {mostraAddCartao && !isEditCards && (
        <>
          <span className={styles['title']} style={{ marginTop: '1.75rem' }}>
            Informe os dados do cartão
          </span>

          {/* ── 3D Card Preview ── */}
          <div
            className={`${styles['card-scene']} ${flipped ? styles['card-scene-flipped'] : ''}`}
            onClick={() => setFlipped((p) => !p)}
          >
            {/* Front */}
            <div className={`${styles['card-face']} ${styles['card-front']}`}>
              <div className={styles['card-top-row']}>
                <div className={styles['card-chip']}>
                  <svg viewBox="0 0 48 36" fill="none" width="36" height="27">
                    <rect x="1" y="1" width="46" height="34" rx="5" stroke="#d4a853" strokeWidth="1.5" fill="#e8c96a" />
                    <line x1="1" y1="13" x2="47" y2="13" stroke="#d4a853" strokeWidth="1" />
                    <line x1="1" y1="23" x2="47" y2="23" stroke="#d4a853" strokeWidth="1" />
                    <line x1="18" y1="1" x2="18" y2="13" stroke="#d4a853" strokeWidth="1" />
                    <line x1="30" y1="23" x2="30" y2="35" stroke="#d4a853" strokeWidth="1" />
                  </svg>
                </div>
                {brand && (
                  <img className={styles['card-brand-logo']} src={brand.logo} alt={brand.name} />
                )}
              </div>
              <div className={styles['card-number']}>{displayNum}</div>
              <div className={styles['card-bottom-row']}>
                <div className={styles['card-holder']}>
                  <span className={styles['card-label']}>TITULAR</span>
                  <span className={styles['card-holder-name']}>{displayName}</span>
                </div>
                <div className={styles['card-expiry']}>
                  <span className={styles['card-label']}>VALIDADE</span>
                  <span className={styles['card-expiry-value']}>{displayExp}</span>
                </div>
              </div>
            </div>

            {/* Back */}
            <div className={`${styles['card-face']} ${styles['card-back']}`}>
              <div className={styles['card-stripe']} />
              <div className={styles['card-cvv-area']}>
                <span className={styles['card-cvv-label']}>CVV</span>
                <div className={styles['card-cvv-box']}>{cvv || '•••'}</div>
              </div>
            </div>
          </div>

          <span className={styles['card-hint']}>Clique no cartão para ver o verso</span>

          {/* ── Form ── */}
          <div className={styles['form-container']}>
            <form className={styles['form']} onSubmit={addCard}>
              <span className={styles['subtitle']}>Dados do Cartão</span>

              <div className={styles['field']}>
                <label className={styles['field-label']}>Número do cartão</label>
                <input
                  className={styles['field-input']}
                  value={formattedNum}
                  onChange={(e) => setNumCartao(mask(e.target.value, ['9999999999999999']))}
                  placeholder="0000 0000 0000 0000"
                  required
                  inputMode="numeric"
                  autoComplete="cc-number"
                />
              </div>

              <div className={styles['field']}>
                <label className={styles['field-label']}>Nome do titular (igual no cartão)</label>
                <input
                  className={styles['field-input']}
                  value={nomeCartao}
                  onChange={(e) => setNomeCartao(e.target.value.toUpperCase())}
                  placeholder="NOME COMPLETO"
                  required
                  autoComplete="cc-name"
                />
              </div>

              <div className={styles['field-row']}>
                <div className={styles['field']}>
                  <label className={styles['field-label']}>Mês</label>
                  <input
                    className={styles['field-input']}
                    value={mesVencimento}
                    onChange={(e) => setmesVencimento(mask(e.target.value, ['99']))}
                    placeholder="MM"
                    required
                    inputMode="numeric"
                    autoComplete="cc-exp-month"
                  />
                </div>
                <div className={styles['field']}>
                  <label className={styles['field-label']}>Ano</label>
                  <input
                    className={styles['field-input']}
                    value={anoVencimento}
                    onChange={(e) => setAnoVencimento(mask(e.target.value, ['99']))}
                    placeholder="AA"
                    required
                    inputMode="numeric"
                    autoComplete="cc-exp-year"
                  />
                </div>
                <div className={styles['field']}>
                  <label className={styles['field-label']}>CVV</label>
                  <input
                    className={styles['field-input']}
                    value={cvv}
                    onChange={(e) => setCvv(mask(e.target.value, ['9999']))}
                    onFocus={() => setFlipped(true)}
                    onBlur={() => setFlipped(false)}
                    placeholder="•••"
                    required
                    inputMode="numeric"
                    autoComplete="cc-csc"
                  />
                </div>
              </div>

              <div className={styles['field']}>
                <label className={styles['field-label']}>CPF ou CNPJ do titular</label>
                <input
                  className={styles['field-input']}
                  value={mask(cpfCnpj, ['999.999.999-99', '99.999.999/9999-99'])}
                  onChange={(e) => setCpfCnpj(mask(e.target.value, ['99999999999', '99999999999999']))}
                  placeholder="000.000.000-00"
                  required
                  inputMode="numeric"
                />
              </div>

              <span className={styles['subtitle']}>Dados Pessoais</span>

              <div className={styles['field']}>
                <label className={styles['field-label']}>Email</label>
                <input
                  className={styles['field-input']}
                  type="email"
                  value={emailTitular}
                  onChange={(e) => setEmailTitular(e.target.value)}
                  placeholder="email@exemplo.com"
                  required
                />
              </div>

              <div className={styles['field']}>
                <label className={styles['field-label']}>CEP</label>
                <input
                  className={styles['field-input']}
                  type="tel"
                  value={mask(cep, ['99999-999'])}
                  onChange={(e) => setCep(mask(e.target.value, ['99999999']))}
                  placeholder="00000-000"
                  required
                  inputMode="numeric"
                />
              </div>

              {endereco && (
                <div className={styles['field']}>
                  <label className={styles['field-label']}>Endereço</label>
                  <input
                    className={styles['field-input']}
                    value={endereco}
                    readOnly
                    style={{ opacity: 0.7 }}
                  />
                </div>
              )}

              {!!contaFatura && (
                <>
                  <span className={styles['subtitle']}>Cobrança</span>
                  <div className={styles['field']}>
                    <label className={styles['field-label']}>Dia da cobrança</label>
                    <input
                      className={styles['field-input']}
                      value={mask(dataCobranca, ['99'])}
                      onChange={(e) => setDataCobranca(mask(e.target.value, ['99']))}
                      placeholder="DD"
                      required
                      inputMode="numeric"
                    />
                  </div>
                </>
              )}

              <Checkbox
                id="PagarAgora"
                label="Pagar Fatura Atual?"
                checked={pagarAgora}
                onChange={() => setPagarAgora((prev) => !prev)}
              />

              <Botao
                type="submit"
                text="Confirmar"
                color="primary-g"
                style={{ width: '100%', marginTop: '0.5rem' }}
                loading={loadingPag}
                disabled={
                  mesVencimento > '12' ||
                  mesVencimento <= '0' ||
                  anoVencimento < anoAtual ||
                  (cpfCnpj.length > 11 && !validaCnpj(cpfCnpj || '00000000000000')) ||
                  (cpfCnpj.length <= 11 && !validaCpf(cpfCnpj || '00000000000'))
                }
              />
            </form>

            <div className={styles['ssl']}>
              <img src={SslImg} alt="site-seguro" className={styles['ssl-img']} />
              <span className={styles['ssl-text']}>&#128274; Site Seguro</span>

              <span className={styles['txt-termos']}>
                <b>TERMOS E CONDIÇÕES</b>: Autorizo a{' '}
                <b>
                  {fatura.nomeempresa?.toUpperCase()} | CNPJ{' '}
                  {fatura.cnpj && mask(fatura.cnpj, ['99.999.999/9999-99'])}
                </b>{' '}
                a debitar em meu Cartão de Crédito o valor correspondente à <b>MENSALIDADE</b> dos
                compromissos da operadora móvel. Comprometo-me, desde já, a manter limite suficiente
                para o referido débito, declarando ciência de que a não liquidação do compromisso
                por insuficiência de limite na data do vencimento, não isenta a obrigação do
                pagamento. Em caso de dúvidas ou reclamação sobre datas de vencimento ou valores,
                devo solicitar esclarecimentos diretamente à empresa. Estou ciente que a Autorização
                de Débito pode ser cancelada por solicitação da {fatura.nomeempresa?.toUpperCase()}{' '}
                ou por mim, nos canais dos chats. Estou ciente que o cancelamento do débito
                automático não implica necessariamente no cancelamento do contrato com a{' '}
                {fatura.nomeempresa?.toUpperCase()}.
              </span>
            </div>
          </div>
        </>
      )}
    </section>
  );
}
